import React from 'react'

function NameColumn({ name }) {
  return (
    <div class='tw-flex-1 tw-min-w-0 tw-items-center tw-hidden md:tw-flex tw-overflow-hidden'>
      <div class='tw-text-[12px] tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap'>
        {name}
      </div>
    </div>
  )
}

export default NameColumn
